<script>
    import R, {LOADER} from "../lib/requests";
    import user from "../stores/user";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import {copyObject, formatDate, scrollTo} from "../lib/lib";
    import PageHeader from "../components/PageHeader.svelte";
    import TableHeader from "../components/TableHeader.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import Pagination from "../components/Pagination.svelte";
    import Checkbox from "../components/controls/Checkbox.svelte";
    import DocumentModal from "./DocumentModal.svelte";
    import DocumentCategoryModal from "./DocumentCategoryModal.svelte";

    const tableColumns = [
        {key: 'title', title: 'ΤΙΤΛΟΣ', sortable: true, sort_way: 'ASC'},
        {key: 'document_category_id', title: 'ΚΑΤΗΓΟΡΙΑ', sortable: true},
        {key: 'document_filename', title: 'ΑΡΧΕΙΟ', sortable: true, class: 'hidden-xs'},
        {key: 'downloaded', title: 'ΤΟ ΕΛΑΒΑΝ', sortable: false, class: 'hidden-xs'},
        {key: 'created_at', title: 'ΚΑΤΑΧΩΡΗΣΗ', sortable: true, class: 'hidden-xs'},
        {key: '', title: ''},
    ];

    const itemsPerPage = [20, 50, 100, 500, 1000];

    let pageHeaderControls = [
        {id: 'create', name: 'ΔΗΜΙΟΥΡΓΙΑ ΕΓΓΡΑΦΟΥ', class: 'hidden-xs'},
        {
            id: 'create',
            name: '',
            icon: 'plus-circle',
            class: 'hidden-xl hidden-lg hidden-md hidden-sm'
        },
        {id: 'reload', name: '', icon: 'refresh'}
    ];

    let categories = [];
    let list = null;
    let total = null;
    let search = {
        // limit: 50,
        // offset: 0,
        sort_field: null,
        sort_way: null,
        document_category_id: '',
        is_active: '',
        title: '',
        document_filename: '',
    };
    let page = 1;
    let selectedId = null;
    let document = null;
    let category = null;

    const emptyDocument = () => {
        return {
            id: 0,
            document_category_id: search.document_category_id,
            title: '',
            description: '',
            document_filename: '',
            filename: '',
            is_active: 1,
        }
    }

    const initialize = () => {
        const onSuccess = result => {
            categories = result.categories;
            load(LOADER.PAGE);
        }

        const onFailure = err => {
        };


        R.handle(R.document.initialize, {}, onSuccess, onFailure, LOADER.PAGE);
    }


    const load = (loader = LOADER.POPUP) => {
        const onSuccess = result => {
            list = result.list;
            total = ~~result.total;
        }

        const onFailure = err => {
        };

        search.offset = (page - 1) * search.limit;

        R.handle(R.document.index, search, onSuccess, onFailure, loader);
    }

    const onSearch = () => {
        page = 1;
        load();
    }

    const onColumnSort = ({detail}) => {
        search.sort_field = detail.key;
        search.sort_way = detail.sort_way;
        load();
    }

    const onCreate = () => {
        document = emptyDocument();
    }

    const onEdit = item => {
        selectedId = item.id;
        document = copyObject(item);
    }

    const closeEdit = param => {
        document = null;
        if (param) {
            load();
        }
    }

    const onDelete = obj => {
        Alert.confirm("Διαγραφή εγγράφου", `Να διαγραφεί οριστικά το έγγραφο "${obj.document_filename}";`, () => deleteDocument(obj.id));
    }

    const deleteDocument = id => {
        const onSuccess = result => {
            list = list.filter(x => x.id != result);
        }

        const onFailure = err => {
        };

        R.handle(R.document.delete, id, onSuccess, onFailure, LOADER.POPUP);
    }

    /* Category handlers */

    const onAddCategory = () => {
        category = {
            id: 0,
            name: '',
            view_index: 0,
        }
    }

    const onEditCategory = () => {
        let item = categories.find(x => x.id == search.document_category_id);
        if (item) {
            category = copyObject(item);
        }
    }

    const closeCategory = param => {
        category = null;
        if (param) {
            let item = categories.find(x => x.id == param.id);
            if (item) {
                item.name = param.name;
                categories = categories;
            } else {
                categories = [...categories, param];
                search.document_category_id = param.id;
                load();
            }
        }
    }

    const onDeleteCategory = () => {
        let category = categories.find(x => x.id == search.document_category_id);
        if (!category) {
            return;
        }
        Alert.confirm("Διαγραφή κατηγορίας", `Να διαγραφεί η κατηγορία "${category.name}";`, () => deleteCategory(category.id));
    }

    const deleteCategory = id => {

        const onSuccess = result => {
            categories = categories.filter(x => x.id != id);
            search.document_category_id = '';
            Notifier.showMessage("Η κατηγορία διαγράφτηκε");
            load();
        }

        const onFailure = err => {
            if (err.code === 'object_related') {
                Alert.warning("Διαγραφή κατηγορίας", "Δεν μπορείτε να διαγράψετε αυτή την κατηγορία όσο είναι συσχετισμένη με έγγραφα!");
            }
        };

        R.handle(R.documentCategory.delete, id, onSuccess, onFailure, LOADER.POPUP);
    }

    initialize();
</script>

<PageHeader title="Έγγραφα Μελών" controls={ pageHeaderControls } on:create={onCreate} on:reload={ load }/>
<div class="row">
    <div class="col-xl-3">
        <div class="panel-simple panel-pad">
            <div class="form-group">
                <select class="form-select" bind:value="{ search.document_category_id }" on:change={ onSearch }>
                    <option value="">κατηγορία</option>
                    {#each categories as category}
                        <option value="{ category.id }">{ category.name }</option>
                    {/each}
                </select>
            </div>
            <div class="btn-group mb-4" style="width:100%" role="group" aria-label="Basic example">
                <button class="btn btn-default" on:click={onAddCategory} title="προσθήκη κατηγορίας">
                    <AppIcon icon="plus-circle" strokeWidth="2"/>
                </button>
                <button class="btn btn-default" title="διόρθωση κατηγορίας" on:click={onEditCategory}
                        disabled="{ !search.document_category_id }">
                    <AppIcon icon="edit" strokeWidth="2"/>
                </button>
                <button class="btn btn-default" title="διαγραφή κατηγορίας" on:click={onDeleteCategory}
                        disabled="{ !search.document_category_id }">
                    <AppIcon icon="trash" strokeWidth="2"/>
                </button>
            </div>
            <hr>
            <div class="form-group">
                <select class="form-select" bind:value="{ search.is_active }" on:change={ onSearch }>
                    <option value="">έγγραφα</option>
                    <option value="1">Ενεργά</option>
                    <option value="0">Ανενεργά</option>
                </select>
            </div>
            <div class="form-group">
                <input type="text" class="form-control" bind:value="{ search.title }" on:change={ onSearch }
                       placeholder="τίτλος">
            </div>
            <div class="form-group">
                <input type="text" class="form-control" bind:value="{ search.document_filename }" on:change={ onSearch }
                       placeholder="όνομα αρχείου">
            </div>
            <button class="btn btn-default btn-block" on:click={onSearch}>Εύρεση</button>
        </div>
    </div>
    <div class="col-xl-9">
        {#if list}
            <table class="table table-list members-list table-list-border mb-4">
                <TableHeader {tableColumns} on:sort={ onColumnSort }/>
                <tbody>
                {#each list as item}
                    <tr class="row-hover" class:row-selected="{ selectedId === item.id }">
                        <td>
                            <div class="is-link" class:not-active="{ item.is_active == 0 }"
                                 on:click="{ () => onEdit(item) }">
                                { item.title }
                            </div>
                        </td>
                        <td class="text-gray hidden-xs">
                            { item.category_name }
                        </td>
                        <td class="text-gray hidden-xs">
                            { item.document_filename }
                        </td>
                        <td class="text-gray text-center hidden-xs">
                            {#if item.downloaded > 0}
                                { item.downloaded }
                            {/if}
                        </td>
                        <td class="year-column text-gray text-center hidden-xs">
                            { formatDate(item.created_at, 'd-m-y') }
                        </td>
                        {#if user.isAdmin()}
                            <td class="button-column pointer" title="διαγραφή εγγράφου"
                                on:click="{ () => onDelete(item) }">
                                <AppIcon icon="trash" size="16"/>
                            </td>
                        {/if}
                    </tr>
                {/each}
                </tbody>
            </table>
        {/if}
    </div>
</div>

{#if document}
    <DocumentModal {document} {categories} closeCallback="{closeEdit}"/>
{/if}
{#if category}
    <DocumentCategoryModal {category} closeCallback="{closeCategory}"/>
{/if}